/** Reset password data dto. */
export class ResetPasswordDataDto {
  constructor(dto) {
    this.password = dto.password;
    this.password_confirmation = dto.password_confirmation;
  }
}
